/* ========================================
   BVROS RECORDS — THEME JS
   ======================================== */

document.addEventListener('DOMContentLoaded', () => {

  // ======= PAGE LOADER =======
  const loader = document.getElementById('pageLoader');
  if (loader) {
    setTimeout(() => loader.classList.add('loaded'), 1400);
  }

  // ======= CUSTOM CURSOR =======
  const cursor = document.getElementById('cursor');
  const follower = document.getElementById('cursor-follower');
  let mouseX = 0, mouseY = 0;
  let followerX = 0, followerY = 0;

  if (cursor && follower && window.innerWidth > 768) {
    document.addEventListener('mousemove', (e) => {
      mouseX = e.clientX;
      mouseY = e.clientY;
      cursor.style.left = mouseX + 'px';
      cursor.style.top = mouseY + 'px';
    });

    function animateFollower() {
      followerX += (mouseX - followerX) * 0.12;
      followerY += (mouseY - followerY) * 0.12;
      follower.style.left = followerX + 'px';
      follower.style.top = followerY + 'px';
      requestAnimationFrame(animateFollower);
    }
    animateFollower();

    document.querySelectorAll('a, button, [data-hover]').forEach(el => {
      el.addEventListener('mouseenter', () => document.body.classList.add('cursor-hover'));
      el.addEventListener('mouseleave', () => document.body.classList.remove('cursor-hover'));
    });
  }

  // ======= HEADER SCROLL =======
  const header = document.querySelector('.site-header');
  if (header) {
    let lastScroll = 0;
    window.addEventListener('scroll', () => {
      const current = window.scrollY;
      header.classList.toggle('scrolled', current > 80);
      lastScroll = current;
    }, { passive: true });
  }

  // ======= SCROLL ANIMATIONS =======
  const fadeEls = document.querySelectorAll('.fade-up');
  if ('IntersectionObserver' in window && fadeEls.length) {
    const obs = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) {
          e.target.classList.add('visible');
          obs.unobserve(e.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -50px 0px' });
    fadeEls.forEach(el => obs.observe(el));
  } else {
    fadeEls.forEach(el => el.classList.add('visible'));
  }

  // ======= CART =======
  window.openCart = function() {
    document.getElementById('cartDrawer')?.classList.add('open');
    document.body.style.overflow = 'hidden';
    refreshCart();
  };

  window.closeCart = function() {
    document.getElementById('cartDrawer')?.classList.remove('open');
    document.body.style.overflow = '';
  };

  async function refreshCart() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      renderCart(cart);
    } catch (e) {
      console.warn('Cart fetch failed:', e);
    }
  }

  function renderCart(cart) {
    const itemsEl = document.getElementById('cartItems');
    const totalEl = document.getElementById('cartTotal');
    if (!itemsEl) return;


  // ======= HERO PARTICLE CANVAS =======
  const canvas = document.querySelector('.hero__particles');
  if (canvas) {
    const ctx = canvas.getContext('2d');
    let W, H, particles = [];

    function resize() {
      W = canvas.width = canvas.offsetWidth;
      H = canvas.height = canvas.offsetHeight;
    }
    resize();
    window.addEventListener('resize', resize, { passive: true });

    const colors = ['rgba(232,201,109,', 'rgba(74,158,255,', 'rgba(212,69,26,'];

    class Particle {
      constructor() { this.reset(); }
      reset() {
        this.x = Math.random() * W;
        this.y = Math.random() * H;
        this.vx = (Math.random() - 0.5) * 0.4;
        this.vy = (Math.random() - 0.5) * 0.4 - 0.2;
        this.life = Math.random();
        this.maxLife = 0.6 + Math.random() * 1.5;
        this.size = 0.5 + Math.random() * 1.5;
        this.color = colors[Math.floor(Math.random() * colors.length)];
      }
      update() {
        this.x += this.vx;
        this.y += this.vy;
        this.life += 0.004;
        if (this.life > this.maxLife || this.x < 0 || this.x > W || this.y < 0) this.reset();
      }
      draw() {
        const alpha = Math.sin((this.life / this.maxLife) * Math.PI) * 0.6;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fillStyle = this.color + alpha + ')';
        ctx.fill();
      }
    }

    for (let i = 0; i < 120; i++) particles.push(new Particle());

    let animId;
    function animate() {
      ctx.clearRect(0, 0, W, H);
      particles.forEach(p => { p.update(); p.draw(); });
      animId = requestAnimationFrame(animate);
    }
    animate();

    // Pause when hero out of view
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(([e]) => {
        if (e.isIntersecting) animate();
        else cancelAnimationFrame(animId);
      }).observe(canvas);
    }
  }

    if (cart.items.length === 0) {
      itemsEl.innerHTML = `
        <div style="text-align:center; padding: 3rem 1rem; color: var(--clr-muted);">
          <div style="font-family: var(--font-display); font-size: 1.5rem; margin-bottom: 1rem;">YOUR CART IS EMPTY</div>
          <a href="/collections/all" class="btn-secondary" onclick="closeCart()">SHOP NOW</a>
        </div>`;
    } else {
      itemsEl.innerHTML = cart.items.map(item => `
        <div style="display:flex; gap:1rem; padding:1rem 0; border-bottom: 1px solid var(--clr-border);">
          <img src="${item.image}" alt="${item.title}" style="width:70px; height:70px; object-fit:cover;">
          <div style="flex:1;">
            <div style="font-family: var(--font-body-cond); font-weight:600; letter-spacing:0.05em; margin-bottom:0.25rem;">${item.product_title}</div>
            <div style="font-size:0.75rem; color: var(--clr-muted); letter-spacing:0.1em; margin-bottom:0.5rem;">${item.variant_title !== 'Default Title' ? item.variant_title : ''}</div>
            <div style="display:flex; align-items:center; justify-content:space-between;">
              <span style="font-family: var(--font-body-cond); color: var(--clr-accent);">${formatMoney(item.final_line_price)}</span>
              <button onclick="removeItem(${item.key})" style="font-size:0.7rem; letter-spacing:0.15em; color: var(--clr-muted); font-family: var(--font-body-cond); text-transform:uppercase; transition: color 0.3s;" onmouseover="this.style.color='var(--clr-text)'" onmouseout="this.style.color='var(--clr-muted)'">REMOVE</button>
            </div>
          </div>
        </div>
      `).join('');
    }

    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    const countEl = document.querySelector('.cart-count');
    if (countEl) countEl.textContent = cart.item_count;
  }

  window.removeItem = async function(key) {
    await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 })
    });
    refreshCart();
  };

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Add to cart
  document.querySelectorAll('[data-add-to-cart]').forEach(btn => {
    btn.addEventListener('click', async (e) => {
      e.preventDefault();
      const variantId = btn.dataset.variantId;
      if (!variantId) return;
      btn.textContent = 'ADDING...';
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        btn.textContent = 'ADDED!';
        setTimeout(() => { btn.textContent = 'ADD TO CART'; }, 1500);
        openCart();
      } catch {
        btn.textContent = 'ERROR';
        setTimeout(() => { btn.textContent = 'ADD TO CART'; }, 1500);
      }
    });
  });

  // ======= PRODUCT GALLERY =======
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImg = document.querySelector('.product-gallery__main img');
  thumbs.forEach(thumb => {
    thumb.addEventListener('click', () => {
      thumbs.forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      if (mainImg) mainImg.src = thumb.querySelector('img')?.src || mainImg.src;
    });
  });

  // ======= OPTION SWATCHES =======
  document.querySelectorAll('.option-swatch').forEach(swatch => {
    swatch.addEventListener('click', () => {
      const group = swatch.closest('.product-option__swatches');
      group?.querySelectorAll('.option-swatch').forEach(s => s.classList.remove('selected'));
      swatch.classList.add('selected');
      const labelEl = swatch.closest('.product-options')
        ?.querySelector('.product-option__label span');
      if (labelEl) labelEl.textContent = swatch.textContent.trim();
    });
  });

  // ======= QTY CONTROL =======
  document.querySelectorAll('.qty-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.qty-control')?.querySelector('.qty-input');
      if (!input) return;
      let v = parseInt(input.value) || 1;
      if (btn.dataset.action === 'minus') v = Math.max(1, v - 1);
      if (btn.dataset.action === 'plus') v = v + 1;
      input.value = v;
    });
  });

  // ======= COLLECTION FILTERS =======
  document.querySelectorAll('.filter-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const filter = btn.dataset.filter;
      document.querySelectorAll('.product-card').forEach(card => {
        if (filter === 'all' || card.dataset.type === filter) {
          card.style.display = '';
        } else {
          card.style.display = 'none';
        }
      });
    });
  });

  // ======= MOBILE NAV =======
  const hamburger = document.querySelector('.hamburger');
  const mobileNav = document.querySelector('.mobile-nav');
  if (hamburger && mobileNav) {
    hamburger.addEventListener('click', () => {
      mobileNav.classList.toggle('open');
      document.body.classList.toggle('nav-open');
    });
  }

  // ======= NEWSLETTER =======
  document.querySelector('.newsletter-form')?.addEventListener('submit', async (e) => {
    e.preventDefault();
    const email = e.target.querySelector('input[type="email"]')?.value;
    const btn = e.target.querySelector('.newsletter-btn');
    if (!email || !btn) return;
    btn.textContent = 'SUBSCRIBING...';
    // Shopify newsletter via customer endpoint
    try {
      const form = new FormData();
      form.append('contact[email]', email);
      await fetch('/contact', { method: 'POST', body: form });
      btn.textContent = 'SUBSCRIBED ✓';
    } catch {
      btn.textContent = 'TRY AGAIN';
      setTimeout(() => { btn.textContent = 'SUBSCRIBE'; }, 2000);
    }
  });

  // ======= PARALLAX HERO =======
  const heroBg = document.querySelector('.hero__bg-img');
  if (heroBg && window.innerWidth > 768) {
    window.addEventListener('scroll', () => {
      const scrolled = window.scrollY;
      heroBg.style.transform = `scale(1.05) translateY(${scrolled * 0.25}px)`;
    }, { passive: true });
  }

  // Initial cart count
  fetch('/cart.js').then(r => r.json()).then(cart => {
    const countEl = document.querySelector('.cart-count');
    if (countEl) countEl.textContent = cart.item_count;
  }).catch(() => {});

});
